import { createSlice } from "@reduxjs/toolkit";
import { getRevenueChartsData } from './thunk';
import { readThunkError } from "../thunkError";

export const initialState = {
  revenueData: [],
  error: {}
};

const DashboardCampaignSlice = createSlice({
  name: 'DashboardCampaign',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getRevenueChartsData.fulfilled, (state, action) => {
      state.revenueData = action.payload;
    });
    builder.addCase(getRevenueChartsData.rejected, (state, action) => {
      state.error = readThunkError(action);
    });
  }
});

export default DashboardCampaignSlice.reducer;